<template>
	<div>
		<v-dialog
			max-width="600px"
			fullscreen
			hide-overlay
			v-model="showDialog"
		>
			<div
				class="header"
				:style="{
					backgroundColor: themeInputColor,
					position: 'fixed'
				}"
			>
				<v-btn
					fab
					flat
					icon
					class="top-left-align pa-0 ma-0 z-index--2"
					@click="goBack"
				>
					<v-icon color="#FFF">arrow_back</v-icon>
				</v-btn>
				Location Review
			</div>
			<div class="container">
				<div v-if="!addressVerificationPage" class="text-xs-center">
					<div class="proofDocument mb-2" style="font-size:12px">
						Business/Shop Photo Submitted by Retailer
					</div>
					<img
						v-if="retailerData.shopImage"
						:src="retailerData.shopImage"
						alt
						class="mb-2 imageSize"
					/>
					<div class="proofDocument mb-2" style="font-size:12px">
						Business/Shop Photo Submitted by TSM
					</div>
					<img
						v-if="retailerData.tsmShopImage"
						:src="retailerData.tsmShopImage"
						alt
						class="mb-2 imageSize"
					/>
					<div class="ma-2">
						<v-btn color="error" @click="openPopup(rejected)"
							>Reject</v-btn
						>
						<v-btn
							color="primary"
							@click="addressVerificationPage = true"
							>Continue</v-btn
						>
					</div>
				</div>
				<div v-else>
					<div class="proofDocument mb-2">Address Submitted</div>
					<v-card class="addressBox font-weight-bold mb-2"
						><div>{{ retailerData.address }}</div>
						<div>
							{{ retailerData.state }}, {{ retailerData.city }}
						</div>
						<div>Pincode: {{ retailerData.pincode }}</div></v-card
					>
					<div class="proofDocument mb-2">
						Address Proof Documents Submitted
					</div>

					<v-card class="pdfCard" v-if="retailerData.addressProof">
						<div class="ma-2">
							{{
								retailerData.addressProof[0].docType === "GST"
									? "GST Certificate"
									: "Current Address Proof"
							}}
						</div>
						<pdf
							:src="{
								url: retailerData.addressProof[0].url
							}"
							:key="retailerData.addressProof[0].url"
							:resize="true"
							:scale.sync="scale"
							style="width:40%;"
						>
							<template slot="loading">
								loading content here...
							</template>
						</pdf>
						<v-layout class="white" style="justify-content:end">
							<v-btn @click="downloadPdf" color="success"
								>Download</v-btn
							>
						</v-layout>
					</v-card>
					<div class="ma-2 text-xs-center">
						<v-btn color="error" @click="openPopup(rejected)"
							>Reject</v-btn
						>
						<v-btn color="primary" @click="openPopup(accepted)"
							>Mark Verified</v-btn
						>
					</div>
				</div>
			</div>
			<v-dialog v-model="showPopup" persistent max-width="600px">
				<v-card class="px-4 py-2">
					<v-card-title class="px-0">
						<span class="title grey-lighten-1--text">{{
							isRejected
								? "Select reason for Rejection"
								: "Checkbox all the options"
						}}</span>
						<v-btn
							icon
							class="top-right-align"
							@click="showPopup = false"
						>
							<v-icon>close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="px-0">
						<v-radio-group v-model="remarks" v-if="isRejected">
							<v-radio
								v-for="text in rejectedReasons"
								:key="text"
								:label="text"
								:value="text"
								@change="val => (remarks = val)"
							></v-radio>
						</v-radio-group>
						<div v-else>
							<v-checkbox
								v-for="text in acceptedReasons"
								v-model="acceptedCheckBox"
								:key="text"
								:label="text"
								:value="text"
							></v-checkbox>
						</div>
						<v-text-field
							v-if="isRejected"
							label="Add Comments"
							class="pr-4"
							outline
							@change="val => (rbmComment = val)"
						></v-text-field>
						<div>
							<v-btn
								v-if="!isRejected"
								class="white--text"
								:color="themeInputColor"
								:loading="isLoading"
								:disabled="acceptedCheckBox.length !== 2"
								@click="updateRetailerStatus(accepted)"
							>
								Retailer Verified
							</v-btn>
							<v-btn
								v-if="isRejected"
								class="white--text"
								color="error"
								:loading="isLoading"
								:disabled="!remarks"
								@click="updateRetailerStatus(pendingToTsm)"
								>Reject to TSM</v-btn
							>
							<v-btn
								v-if="isRejected"
								class="white--text"
								color="error"
								:loading="isLoading"
								:disabled="!remarks"
								@click="updateRetailerStatus(rejected)"
								>Reject to Retailer</v-btn
							>
						</div>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-dialog>
		<div v-if="!showDialog">
			<div class="px-2">Search Retailers</div>
			<v-text-field
				outlined
				v-model="searchPhoneNo"
				placeholder="Enter Phone Number"
				@change="updateSearchValue"
				type="number"
				class="px-2"
			></v-text-field>
			<v-card
				v-for="item in retailersVisitList.filter(
					item =>
						`${item.phoneNo}`.includes(searchPhoneNo) &&
						item.shopStatus === pendingToRbm
				)"
				:key="item.userId"
				style="display:flex;justify-content: space-around;"
				class="mb-2"
				><div class="pa-2 alignInColumn">
					<div class="font-weight-bold mb-2">
						{{ item.retailerName || "-" }}
					</div>
					<div>{{ item.phoneNo || "-" }}</div>
				</div>
				<div class="pa-2">
					<v-btn
						color="primary"
						@click="showRetailer(item)"
						style="min-width: 150px;"
						>Verify</v-btn
					>
				</div></v-card
			>
			<div style="display: flex;justify-content: center" class="mb-2">
				<v-icon
					v-if="offset"
					color="#000"
					style="cursor: pointer"
					@click="changeOffset('dec')"
					>chevron_left</v-icon
				><v-icon
					v-if="retailersVisitList.length === limit"
					color="#000"
					style="cursor: pointer"
					@click="changeOffset('inc')"
					>chevron_right</v-icon
				>
			</div>
		</div>
		<div v-if="isLoading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import pdf from "pdfvuer";
import { THEME_INPUT_COLOUR } from "../constants";
import {
	RETAILERS_VISIT_LIST,
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	UPDATE_RETAILER_STATUS
} from "../../store/action-types";
import { __fileDownload } from "../../utils";

export default {
	name: "TaskReviewSection",
	data: () => ({
		isLoading: false,
		showDialog: false,
		themeInputColor: THEME_INPUT_COLOUR,
		limit: 100,
		offset: 0,
		retailersVisitList: [],
		searchPhoneNo: "",
		accepted: "accepted",
		rejected: "rejected",
		pendingToRbm: "pendingToRbm",
		pendingToTsm: "pendingToTsm",
		selectedRetailer: {},
		retailerData: {},
		showPopup: false,
		remarks: "",
		rejectedReasons: [
			"Address not Matching",
			"Photo Mismatch submitted by Retailer",
			"Photo Mismatch submitted by TSM"
		],
		acceptedReasons: ["Address Matching", "Photos submitted are matching"],
		isRejected: false,
		rbmComment: "",
		acceptedCheckBox: [],
		addressVerificationPage: false
	}),
	mounted() {
		this.fetchRetailersVisitList();
	},
	components: {
		pdf
	},
	computed: {
		...mapState({
			userId: state => state.auth.USERID
		})
	},
	methods: {
		fetchRetailersVisitList() {
			this.isLoading = true;
			this.$store
				.dispatch(RETAILERS_VISIT_LIST.dispatch, {
					limit: this.limit,
					offset: this.offset,
					userId: this.userId
				})
				.then(data => {
					this.retailersVisitList = data.retailers || [];
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		getRetailerData(phoneNo) {
			this.isLoading = true;
			this.$store
				.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
					p: phoneNo,
					isSchemeRequired: true
				})
				.then(data => {
					this.retailerData = data || {};
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		updateRetailerStatus(shopStatus) {
			this.isLoading = true;
			if (this.rbmComment) this.remarks += `,${this.rbmComment}`;
			const payload =
				shopStatus === this.rejected || shopStatus === this.pendingToTsm
					? {
							userId: this.selectedRetailer.userId,
							shopStatus,
							remarks: this.remarks
					  }
					: {
							userId: this.selectedRetailer.userId,
							shopStatus
					  };
			this.$store
				.dispatch(UPDATE_RETAILER_STATUS.dispatch, payload)
				.then(() => {
					this.showDialog = false;
					this.fetchRetailersVisitList();
					this.searchPhoneNo = "";
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		downloadPdf() {
			__fileDownload(
				this.retailerData.addressProof
					? this.retailerData.addressProof[0].url
					: ""
			);
		},
		updateSearchValue(val) {
			this.searchPhoneNo = val;
		},
		showRetailer(data) {
			this.selectedRetailer = data;
			this.showDialog = true;
			this.getRetailerData(data.phoneNo);
		},
		changeOffset(updateValue) {
			if (updateValue === "inc") this.offset += this.limit;
			else this.offset -= this.limit;
			this.fetchRetailersVisitList();
		},
		openPopup(status) {
			this.isRejected = status === this.rejected;
			this.showPopup = true;
			this.remarks = "";
			this.rbmComment = "";
		},
		goBack() {
			this.showDialog = false;
			this.addressVerificationPage = false;
		}
	}
};
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 65px;
}
.proofDocument {
	font-weight: 400;
	font-size: 16px;
	color: #00000073;
}
.pdfCard {
	background: #fafafa;
	margin: 1rem 0rem;
	padding: 10px 20px;
}
.addressBox {
	background: rgb(245, 245, 245);
	width: 100%;
	padding: 0.5rem;
	display: flex;
	flex-direction: column;
}
.alignInColumn {
	display: flex;
	flex-direction: column;
}
.imageSize {
	min-width: 300px;
	height: 300px;
}
</style>
